import { render } from "./TreasuryView.vue?vue&type=template&id=f321a34e&scoped=true"
import script from "./TreasuryView.vue?vue&type=script&lang=js"
export * from "./TreasuryView.vue?vue&type=script&lang=js"

import "./TreasuryView.vue?vue&type=style&index=0&id=f321a34e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f321a34e"]])

export default __exports__